import { FontFaceTheme } from '@kite-js/theme-types';
import families from './families';

const interState: FontFaceTheme = {
    fontFamily: families.interState,
    fontFaces: [
        {
            primarySrc: "url('//img.agoda.net/images/kite-js/fonts/interstate-light.otf')",
            secondarySrc: '',
            fontWeight: 300,
            fontStyle: 'normal',
        },
        {
            primarySrc: "url('//img.agoda.net/images/kite-js/fonts/interstate-regular.otf')",
            secondarySrc: '',
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: "url('//img.agoda.net/images/kite-js/fonts/interstate-bold.otf')",
            secondarySrc: '',
            fontWeight: 500,
            fontStyle: 'normal',
        },
    ],
};

const faces: FontFaceTheme[] = [interState];

export default faces;
